export default "__VITE_ASSET__G8O6Pc5c__"